import { GlobalPageLoadExperience } from '@atlassian/ufo';
import { getVersionId, useDatabaseContent } from '@databases/database-state';
import { appStoreUtils } from '@databases/redux/store';
import { getBridgeAPI } from '@databases/utils/database/bridge';
import { selectDatabaseByContentIdStatus } from '@databases/utils/redux/databases/selectors';
import { AsyncOperationStatus } from '@databases/utils/redux/redux';
import { isStandalone as isStandaloneCheck } from '@databases/utils/utils';
import React, { FunctionComponent, useEffect } from 'react';

import { DatabaseError } from './DatabaseError';
import { DatabaseActionKey } from './common/components/database/DatabaseActions';
import DatabaseContent from './common/components/database-content/DatabaseContent';
import DatabaseContentSkeleton from './common/components/database-content/DatabaseContentSkeleton';

const isStandalone = isStandaloneCheck();

const actions: DatabaseActionKey[] = ['import', 'print', 'help', 'copy', 'feedback'];
if (isStandalone) {
  actions.push('lock');
}

const DatabaseContentLoader: FunctionComponent = () => {
  const { contentId } = useDatabaseContent() as { contentId: string };
  const versionId = getVersionId();

  const databaseStatus = appStoreUtils.useEqualSelector((state) =>
    selectDatabaseByContentIdStatus(state, { contentId })
  );

  useEffect(() => {
    const logMetrics = async () => {
      GlobalPageLoadExperience.mark('database-load-end');
      GlobalPageLoadExperience.success({ force: true });
      (await getBridgeAPI()).onContentLoadSucceeded?.({});
    };

    if (databaseStatus?.status === AsyncOperationStatus.SUCCEEDED) {
      logMetrics();
    }
  }, [databaseStatus?.status, contentId]);

  if (databaseStatus?.status === AsyncOperationStatus.ERROR) {
    return <DatabaseError serializedError={databaseStatus.error} />;
  } else if (databaseStatus?.status === AsyncOperationStatus.SUCCEEDED) {
    return (
      <DatabaseContent
        contentId={contentId}
        isContentEditable={!versionId}
        actions={actions}
      />
    );
  } else {
    return <DatabaseContentSkeleton />;
  }
};

export default DatabaseContentLoader;
